export const NPS_URL = `/nps`;

export const ICICI_POP_CODE = process.env.REACT_APP_ICICI_POP_CODE || "1010578";
export const ICICI_POP_SP_CODE =
  process.env.REACT_APP_ICICI_POP_SP_CODE || "1010586";
export const HDFC_POP_CODE = process.env.REACT_APP_HDFC_POP_CODE || "1011501";
export const HDFC_POP_SP_CODE =
  process.env.REACT_APP_HDFC_POP_SP_CODE || "1011501";
export const ADITYA_POP_CODE =
  process.env.REACT_APP_ADITYA_POP_CODE || "1010610";
export const ADITYA_POP_SP_CODE =
  process.env.REACT_APP_ADITYA_POP_SP_CODE || "1010628";

export const HDFC_URL =
  process.env.REACT_APP_HDFC_URL ||
  " https://uatcra.kfintech.com/poponline/POPContributeOnline?AuthID=E59C9766C7B80F2D3C7A7B89474340CFAE4255FDC449305636A7483150C48563";
export const ICICI_URL =
  process.env.REACT_APP_ICICI_URL ||
  " https://uatcra.kfintech.com/poponline/POPContributeOnline?AuthID=C605469B4ADABAD2F2CE8AB1163D49FE100CB12780764A7A2C99515E67C26E75";
export const ADITYA_URL =
  process.env.REACT_APP_ADITYA_URL ||
  "https://uatcra.kfintech.com/poponline/POPContributeOnline?AuthID=3E5E3D8EC044D25CFFFA8B4A7340E4029C54353AA374CAF0D4992476AC152786";

export const POP_LIST = [
  {
    popCode: HDFC_POP_CODE,
    popSpCode: HDFC_POP_SP_CODE,
  },
  {
    popCode: ADITYA_POP_CODE,
    popSpCode: ADITYA_POP_SP_CODE,
  },
  {
    popCode: ICICI_POP_CODE,
    popSpCode: ICICI_POP_SP_CODE,
  },
];

export const POP_CONFIG = [
  {
    name: "HDFC",
    popCode: HDFC_POP_CODE,
    popSpCode: HDFC_POP_SP_CODE,
    subsequentUrl: HDFC_URL,
  },
  {
    name: "ADITYA",
    popCode: ADITYA_POP_CODE,
    popSpCode: ADITYA_POP_SP_CODE,
    subsequentUrl: ADITYA_URL,
  },
  {
    name: "ICICI",
    popCode: ICICI_POP_CODE,
    popSpCode: ICICI_POP_SP_CODE,
    subsequentUrl: ICICI_URL,
    sipUrl:
      "https://www.iciciprupensionfund.com/POP_NPS/views/base/StandardInstructionsForm.iview",
  },
];
